import { render, staticRenderFns } from "./board-filter.vue?vue&type=template&id=235b173e&"
import script from "./board-filter.vue?vue&type=script&lang=js&"
export * from "./board-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports